import api, { getInvoiceSetup } from '../../../services/api';
import { getSelectedHotelFromContext } from './grcUtils';

let brandingCache = null;
let brandingCacheKey = '';
let brandingRequest = null;

function getHotelCacheKey(hotel = getSelectedHotelFromContext()) {
  return String(hotel.id || hotel.pk || hotel.code || hotel.name || 'default');
}

export function getHotelBrandingFromContext() {
  const hotel = getSelectedHotelFromContext();
  return {
    hotelName: hotel.name || '',
    address: hotel.address || '',
    city: hotel.city || '',
    gstin: hotel.gstin || '',
    phone: hotel.phone_number || hotel.phone || '',
    email: hotel.contact_email || hotel.email || '',
    logoUrl: hotel.logo_url || '',
    checkInTime: hotel.check_in_time || '',
    checkOutTime: hotel.check_out_time || '',
    tagline: '',
  };
}

export async function loadHotelBranding() {
  const cacheKey = getHotelCacheKey();
  if (brandingCache && brandingCacheKey === cacheKey) return brandingCache;
  if (brandingRequest?.key === cacheKey) return brandingRequest.promise;

  const promise = fetchHotelBranding()
    .then((branding) => {
      brandingCache = branding;
      brandingCacheKey = cacheKey;
      return branding;
    })
    .finally(() => {
      if (brandingRequest?.key === cacheKey) brandingRequest = null;
    });

  brandingRequest = { key: cacheKey, promise };
  return promise;
}

async function fetchHotelBranding() {
  const next = getHotelBrandingFromContext();
  const [setupResult, themeResult, gstinResult] = await Promise.allSettled([
    getInvoiceSetup(),
    api.get('/distribution/api/nexastay-theme/'),
    api.get('/configuration/api/hotel-gstin/'),
  ]);

  if (setupResult.status === 'fulfilled') {
    const settings = setupResult.value?.settings || {};
    next.logoUrl = settings.invoice_logo_url || next.logoUrl;
    next.tagline = settings.tagline || next.tagline;
  }
  if (!next.logoUrl && themeResult.status === 'fulfilled') {
    next.logoUrl = themeResult.value?.data?.logo_url || next.logoUrl;
  }
  if (!next.gstin && gstinResult.status === 'fulfilled') {
    next.gstin = gstinResult.value?.data?.gstin || next.gstin;
  }

  return next;
}
